<template>
  <div class="bg-gray-900" @click="handleOutsideClick">
    <!-- Botón de menú para dispositivos móviles -->
    <button
      @click="toggleMenu"
      aria-controls="sidebar"
      type="button"
      class="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-orange-500 dark:focus:ring-gray-600"
    >
      <span class="sr-only">Open sidebar</span>
      <svg
        class="w-6 h-6"
        aria-hidden="true"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          clip-rule="evenodd"
          fill-rule="evenodd"
          d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
        ></path>
      </svg>
    </button>
  </div>

  <!-- Sidebar -->
  <aside
    :class="{ 'translate-x-0': isMenuOpen, '-translate-x-full': !isMenuOpen }"
    id="sidebar"
    class="fixed top-0 left-0 z-40 w-64 h-screen transition-transform bg-gray-50 dark:bg-gray-800"
  >
    <div class="h-full px-3 py-4 overflow-y-auto">
      <ul class="space-y-2 font-medium">
        <li>
          <router-link
            to="/"
            class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-500 group"
            exact-active-class="bg-gray-100 dark:bg-orange-500"
          >
            <i
              class="fa fa-home text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            ></i>
            <span class="ms-3">Inicio</span>
          </router-link>
        </li>

        <!-- Divider -->
        <hr class="my-4 border-gray-300 dark:border-gray-700" />

        <!-- Categoría: Ventas -->
        <li
          class="text-gray-500 dark:text-gray-400 text-sm uppercase font-semibold"
        >
          <span class="px-3 py-2">Ventas</span>
        </li>

        <li>
          <router-link
            to="/venta"
            class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-500 group"
            exact-active-class="bg-gray-100 dark:bg-orange-500"
          >
            <i
              class="fa fa-file text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            ></i>
            <span class="ms-3">Nueva venta</span>
          </router-link>
        </li>
        <li>
          <router-link
            to="/ventas"
            class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-500 group"
            exact-active-class="bg-gray-100 dark:bg-orange-500"
          >
            <i
              class="fa fa-list text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            ></i>
            <span class="ms-3">Historial Ventas</span>
          </router-link>
        </li>

        <!-- Divider -->
        <hr class="my-4 border-gray-300 dark:border-gray-700" />

        <!-- Categoría: Gastos -->
        <li
          class="text-gray-500 dark:text-gray-400 text-sm uppercase font-semibold"
        >
          <span class="px-3 py-2">Gastos</span>
        </li>

        <li>
          <router-link
            to="/gasto"
            class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-500 group"
            exact-active-class="bg-gray-100 dark:bg-orange-500"
          >
            <i
              class="fa fa-file text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            ></i>
            <span class="ms-3">Nuevo Gasto</span>
          </router-link>
        </li>
        <li>
          <router-link
            to="/gastos"
            class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-500 group"
            exact-active-class="bg-gray-100 dark:bg-orange-500"
          >
            <i
              class="fa fa-list text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            ></i>
            <span class="ms-3">Historial Gastos</span>
          </router-link>
        </li>

        <!-- Divider -->
        <hr class="my-4 border-gray-300 dark:border-gray-700" />

        <!-- Categoría: Presupuestos -->
        <li
          class="text-gray-500 dark:text-gray-400 text-sm uppercase font-semibold"
        >
          <span class="px-3 py-2">Presupuestos</span>
        </li>

        <li>
          <router-link
            to="/presupuesto"
            class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-500 group"
            exact-active-class="bg-gray-100 dark:bg-orange-500"
          >
            <i
              class="fa fa-file text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            ></i>
            <span class="ms-3">Generar presupuesto</span>
          </router-link>
        </li>
        <li>
          <router-link
            to="/presupuestos"
            class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-500 group"
            exact-active-class="bg-gray-100 dark:bg-orange-500"
          >
            <i
              class="fa fa-list text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            ></i>
            <span class="ms-3">Historial presupuestos</span>
          </router-link>
        </li>

        <!-- Divider -->
        <hr class="my-4 border-gray-300 dark:border-gray-700" />

        <!-- Categoría: Productos -->
        <li
          class="text-gray-500 dark:text-gray-400 text-sm uppercase font-semibold"
        >
          <span class="px-3 py-2">Reportes</span>
        </li>
        <li>
          <router-link
            to="/reportes"
            class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-500 group"
            exact-active-class="bg-gray-100 dark:bg-orange-500"
          >
            <i
              class="fa fa-pie-chart text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            ></i>
            <span class="ms-3">Estadisticas</span>
          </router-link>
        </li>
        <!-- Divider -->
        <hr class="my-4 border-gray-300 dark:border-gray-700" />

        <!-- Categoría: Productos -->
        <li
          class="text-gray-500 dark:text-gray-400 text-sm uppercase font-semibold"
        >
          <span class="px-3 py-2">Productos</span>
        </li>
        <li>
          <router-link
            to="/productos"
            class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-500 group"
            exact-active-class="bg-gray-100 dark:bg-orange-500"
          >
            <i
              class="fa fa-box text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            ></i>
            <span class="ms-3">Ver Productos</span>
          </router-link>
        </li>

        <!-- Divider -->
        <hr class="my-4 border-gray-300 dark:border-gray-700" />

        <!-- Categoría: Clientes -->
        <li
          class="text-gray-500 dark:text-gray-400 text-sm uppercase font-semibold"
        >
          <span class="px-3 py-2">Clientes</span>
        </li>
        <li>
          <router-link
            to="/clientes"
            class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-500 group"
            exact-active-class="bg-gray-100 dark:bg-orange-500"
          >
            <i
              class="fa fa-user text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            ></i>
            <span class="ms-3">Clientes</span>
          </router-link>
        </li>

        <!-- Divider -->
        <hr class="my-4 border-gray-300 dark:border-gray-700" />

        <li>
          <a
            href="#"
            @click.prevent="cerrarSesion"
            class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-500 group"
          >
            <i
              class="fa fa-angle-double-left text-gray-500 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            ></i>
            <span class="ms-3">Cerrar sesión</span>
          </a>
        </li>

        <li>
          <a
            href="#"
            @click="comprobarActualizacion"
            class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-500 group"
          >
            <i
              class="fa fa-refresh text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            ></i>
            <span class="ms-3">Actualizar versión</span>
          </a>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import AuthStateHelper from "../helpers/authStateHelper";
import { useRouter } from 'vue-router';

const isMenuOpen = ref(false);
const router = useRouter();

// Detectar el tamaño de la pantalla
const setMenuState = () => {
  if (window.innerWidth >= 640) {
    isMenuOpen.value = true;
  } else {
    isMenuOpen.value = false;
  }
};

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

const cerrarSesion = () => {
  AuthStateHelper.deleteAuth();
  router.push("/login");
};

// Cerrar el menú si se hace clic fuera de él
const handleOutsideClick = (event) => {
  if (window.innerWidth < 640) {
    const sidebar = document.getElementById("sidebar");
    const button = event.target.closest("button");

    // Si el clic no es en el botón ni en el menú, cierra el menú
    if (!sidebar.contains(event.target) && !button) {
      isMenuOpen.value = false;
    }
  }
};
const comprobarActualizacion = () => {
  console.log("Comprobando actualizaciones...");
  window.location.reload(true);
};

// Inicializa el estado al cargar el componente
onMounted(() => {
  setMenuState();
  window.addEventListener("resize", setMenuState);
  document.addEventListener("click", handleOutsideClick); // Escucha clics fuera del menú
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleOutsideClick); // Limpia el evento cuando se desmonta el componente
});
</script>

<style scoped>
/* Personalización de estilos aquí */
</style>
